module.exports = __webpack_public_path__ + "static/media/spinner.f02a681c.gif";